export class ResetStates {
  public static readonly type = '[User] ResetStates';
}
